import { useState } from 'react';
import { Button } from 'modules/Button';
import { Menu } from 'modules/Menu';
import { Typography } from 'modules/Typography';
import { Falcon } from 'modules/macro';
export function TableColumnToggle(props) {
    const { children, headers, onChange, size, appearance = 'ghost' } = props;
    const headerOptions = headers.map((header) => { var _a; return (Object.assign(Object.assign({}, header), { active: (_a = header.active) !== null && _a !== void 0 ? _a : true })); });
    const [colRows, setColRows] = useState(headerOptions);
    const handleChange = (name, checked) => {
        const newState = colRows.map((col) => {
            if (col.id === name) {
                return Object.assign(Object.assign({}, col), { active: checked });
            }
            return col;
        });
        setColRows(newState);
        onChange(newState);
    };
    return (<Menu.Root target={<Button appearance={appearance} size={size}>
          <Falcon icon="table-columns"/>
          <Typography>{children}</Typography>
        </Button>}>
      {colRows.map(({ id, label, disabled, active }) => (<Menu.ItemSwitch disabled={disabled} key={id} checked={active} onChange={() => handleChange(id, !active)}>
          {label || id}
        </Menu.ItemSwitch>))}
    </Menu.Root>);
}
